import Vue from 'vue';
import router from '../../router';
import utils from '../../others/utils';
import { Loading } from 'quasar';

export default {
  loadWikis(context, refresh = false) {
    console.log('loadWikis access_token, refresh', context.rootState.user.access_token, refresh);
    return new Promise((resolve, reject) => {
      if (utils.isEmptyObject(context.state.wikis) || refresh) {
        Loading.show();
        context.dispatch('waitRefresh', null, { root: true })
          .then(() => fetch('/loadwikis', {
            method: 'GET',
            headers: { authorization: context.rootState.user.access_token },
          }))
          .then(res => res.json())
          .then((res) => {
            Loading.hide();
            console.log('loadWikis res', res);
            if (res.error) {
              console.log('loadWikis result error', res.error);
              reject(res);
            } else {
              context.commit('setW_P', res);
              resolve(true);
            }
          })
          .catch((err) => {
            Loading.hide();
            console.log('loadWikis error', err);
            reject(err);
          });
      } else { // nothing to do
        resolve(false);
      }
    });
  },
  loadWiki(context, data) {
    const fullId = data.fullId;
    const refresh = data.refresh || false;
    console.log('loadWiki context.state.currentItem._id, fullId, refresh', context.state.currentItem
      && context.state.currentItem._id, fullId, refresh);
    return new Promise((resolve, reject) => {
      if (!context.state.currentItem
        || !context.state.currentItem._id
        || refresh
        || fullId !== context.getters.currentFullId) {
        if (fullId) {
          context.commit('setCurrentItem', null);
          context.commit('setAuthorName', null);
          context.dispatch('waitRefresh', null, { root: true })
            .then(() => fetch(`/loadwikis?id=${fullId}`, {
              method: 'GET',
              headers: { authorization: context.rootState.user.access_token },
            }))
            .then(res => res.json())
            .then((res) => {
              console.log('loadWiki res', res);
              if (res.error) {
                console.log('loadWiki result error', res.error);
                throw res;
              } else {
                context.commit('setCurrentItem', res);
                return context.dispatch('getAuthorName');
              }
            })
            .then(() => resolve(true))
            .catch((err) => {
              console.log('loadWikis error', err);
              context.commit('pushError', err, { root: true });
              const h = typeof (err.error) === 'string' ? err.error : typeof (err.name) === 'string' ? err.name : 'Oops!';
              context.commit('setCurrentItem', {
                title: '** Ошибка **',
                content: `<h3 style="color:red">${h}</h3><p>${err.message}</p>`,
              });
              resolve(false);
            });
        } else {
          reject(new Error('No id'));
        }
      } else {
        console.log('loadWiki nothing to do!');
        resolve(false);
      }
    });
  },
  getAuthorName(context) {
    const r0 = context.state.currentItem && context.state.currentItem.author;
    return new Promise((resolve, reject) => {
      if (r0) {
        context.dispatch('waitRefresh', null, { root: true })
          .then(() => fetch(`/username?r=${r0}`, {
            method: 'GET',
            headers: { authorization: context.rootState.user.access_token },
          }))
          .then(res => res.json())
          .then((res) => {
            console.log('username res', res);
            if (res.error) {
              console.log('username result error', res.error);
              reject(res);
            } else {
              context.commit('setAuthorName', res.name);
              resolve(true);
            }
          })
          .catch((err) => {
            console.log('username error', err);
            reject(err);
          });
      } else {
        context.commit('setAuthorName', null);
        resolve(false);
      }
    });
  },
  saveMedia(context, data) {
    console.log('saveMedia data', data);
    return new Promise((resolve, reject) => {
      context.dispatch('waitRefresh', null, { root: true })
        .then(() => fetch('/wikimedia', {
          method: 'OPTIONS', // test if media already exists
          body: JSON.stringify({ id: data._id }),
          headers: {
            authorization: context.rootState.user.access_token,
            'Content-Type': 'application/json',
          },
        }))
        .then(res => res.json())
        .then((res) => {
          console.log('wikimedia res', res);
          if (res.error) {
            reject(res);
          } else if (res.result) {
            resolve(data._id); // already exists
          } else { // doesn't exist
            const form = new FormData();
            form.append('file', data._attachments.media.data);
            form.append('id', data._id);
            form.append('content_type', data._attachments.media.content_type);
            context.dispatch('waitRefresh', null, { root: true })
              .then(() => fetch('/wikimedia', {
                method: 'POST',
                body: form,
                headers: {
                  authorization: context.rootState.user.access_token,
                },
              }))
              .then(res2 => res2.json())
              .then((res3) => {
                console.log('wikimedia res', res3);
                if (res3.error) {
                  reject(res3);
                } else {
                  resolve(data._id); // saved
                }
              });
          }
        })
        .catch((err) => {
          console.log('saveMedia err', err);
          reject(err);
        });
    });
    /* return new Promise((resolve, reject) => {
        context.dispatch('waitRefresh', null, { root: true })
          .then(() => fetch('/savemedia', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { authorization: context.rootState.user.access_token },
          }))
          .then(res => res.json())
          .then((res) => {
            console.log('savewiki res', res);
            if (res.error) {
              reject(res);
            } else {
              if (!publish) { // draft
                context.dispatch('loadWiki', { fullId: res.savedFullId, refresh: true });
                if (big) {
                  context.dispatch('loadWikis', true);
                }
              } else { // it's now assigned to server
                // context.dispatch('sendMessage', { cmd: 'UPDATE-OTHER', id: res.savedFullId, big });
                // context.dispatch('UPDATE', { id: res.savedFullId, big });
              }
              resolve(res.savedFullId);
            }
          })
          .catch((err) => {
            console.log('savewiki err', err);
            reject(err);
          }); */
  },
  saveWiki(context, data) {
    console.log('saveWiki data', data);
    const item = data.item;
    const publish = data.publish;
    let big = data.bigChange;
    const type = context.getters.currentType;
    const from = context.getters.currentFullId;
    const _clearIfVar = () => {
      delete item.tags;
      delete item.title;
      delete item.order;
      delete item.parent_id;
    };
    const _genId = () => {
      const t = (new Date().getTime() / 1000 | 0).toString(16);
      return `${t}${'xxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
    };
    delete item._id;
    delete item._rev;
    if (publish) {
      switch (type) {
        case 'a':
          item.fullId = from;
          break;
        case 'd':
          item.fullId = `a:${utils.getId(from, 1)}`;
          big = true;
          break;
        case 'v':
          item.fullId = `a:${utils.getId(from, 1)}`;
          big = false;
          break;
        default: // none
          item.fullId = `a:${_genId()}`;
          big = true;
      }
    } else {
      switch (type) {
        case 'a':
          _clearIfVar();
          item.fullId = `v:${utils.getId(from, 1)}`;
          big = true;
          break;
        case 'd':
          item.fullId = from;
          break;
        case 'v':
          _clearIfVar();
          item.fullId = from;
          big = false;
          break;
        default: // none
          item.fullId = `d:${_genId()}`;
          big = true;
      }
    }
    console.log('saveWiki item', item);
    return new Promise((resolve, reject) => {
      context.dispatch('waitRefresh', null, { root: true })
        .then(() => fetch('/savewiki', {
          method: 'POST',
          body: JSON.stringify(item),
          headers: { authorization: context.rootState.user.access_token },
        }))
        .then(res => res.json())
        .then((res) => {
          console.log('savewiki res', res);
          if (res.error) {
            reject(res);
          } else {
            if (!publish) { // draft
              context.dispatch('loadWiki', { fullId: res.savedFullId, refresh: true });
              if (big) {
                context.dispatch('loadWikis', true);
              }
            } else { // it's now assigned to server
              // context.dispatch('sendMessage', { cmd: 'UPDATE-OTHER', id: res.savedFullId, big });
              // context.dispatch('UPDATE', { id: res.savedFullId, big });
            }
            resolve(res.savedFullId);
          }
        })
        .catch((err) => {
          console.log('savewiki err', err);
          reject(err);
        });
    });
  },
  deleteDraft(context, fullId) {
    console.log('deleteDraft', fullId);
    return new Promise((resolve, reject) => {
      context.dispatch('waitRefresh', null, { root: true })
        .then(() => fetch('/deletedraft', {
          method: 'POST',
          body: JSON.stringify({ id: fullId }),
          headers: { authorization: context.rootState.user.access_token },
        }))
        .then(res => res.json())
        .then((res) => {
          console.log('deleteDraft res', res);
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
        .catch((err) => {
          console.log('deleteDraft err', err);
          reject(err);
        });
    });
  },
  PING() {
    console.log('PING');
  },
  PONG() {
    console.log('PONG');
  },
  UPDATE(context, data) {
    console.log('UPDATE', data.id, data.big);
    if (data.big) {
      context.dispatch('loadWikis', true);
    }
    // refresh currentItem if it has been changed
    if (context.getters.currentFullId === data.id) {
      context.dispatch('loadWiki', { fullId: data.id, refresh: true });
    }
  },
  HELLO(context, data) {
    console.log('HELLO', data.user);
  },
  AUTH_ERROR(context, data) {
    console.log('AUTH_ERROR', data.error);
    if (data.error === 401) {
      router.push('/sign-in');
    }
  },
  sendMessage(context, data) {
    context.dispatch('waitRefresh', null, { root: true })
      .then(() => Vue.prototype.$socket.sendObj(Object.assign({ token: context.rootState.user.access_token }, data)));
  },
};



// WEBPACK FOOTER //
// ./src/store/wiki/actions.js